class Utils {
    // Formats a given amount as a dollar currency string.

    static isValidColor = (color) => {
        const s = new Option().style;
        s.color = color;
        return s.color !== '';
    };

    static formatDollar(amount) {
        // Regex expression taken from https://stackoverflow.com/questions/2901102
        return '$' + amount.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }

    static  formatTodayDate = (date) => {
        const options = {
            timeZone: 'America/Chicago',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };

        const formatter = new Intl.DateTimeFormat('en-US', options);
        const parts = formatter.formatToParts(date);

        // Extract year, month, and day parts
        const year = parts.find(part => part.type === 'year').value;
        const month = parts.find(part => part.type === 'month').value;
        const day = parts.find(part => part.type === 'day').value;

        // Format as YYYY-MM-DD
        return `${year}-${month}-${day}`;
    }

    //10/26/2024 4:53 p.m.
    static formatDateMMDDYYYYTime = (dateString) => {
        // Parse the date string
        const date = new Date(dateString.replace(/(a\.m\.|p\.m\.)/i, 'AM').replace(/(p\.m\.)/i, 'PM'))

        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}-${month}-${day}`
    };

    static convertTo12HourFormat = (time24) => {
        // Check if the input time is valid
        if (!/^\d{2}:\d{2}:\d{2}$/.test(time24)) {
            throw new Error('Invalid time format. Expected HH:mm:ss.');
        }

        // Create a new Date object and set hours, minutes, and seconds
        const [hours, minutes, seconds] = time24.split(':').map(Number);
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(seconds);

        // Format the time using options
        const options = {
            hour: '2-digit',
            minute: '2-digit',
            // second: '2-digit',
            hour12: true, // Use 12-hour clock with AM/PM
        };

        // Convert to 12-hour format
        return date.toLocaleTimeString('en-US', options);
    };
}



export default Utils;
